import { render, staticRenderFns } from "./FloatingSettings.vue?vue&type=template&id=c2578666&scoped=true"
import script from "./FloatingSettings.vue?vue&type=script&lang=js"
export * from "./FloatingSettings.vue?vue&type=script&lang=js"
import style0 from "./FloatingSettings.vue?vue&type=style&index=0&id=c2578666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2578666",
  null
  
)

export default component.exports